module.exports = __webpack_public_path__ + "static/media/target.952c186f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/target.svg
// module id = 274
// module chunks = 3